<template>
  <div class="rate">
    <input type="radio" id="star5" name="rate" value="5" @change="storeStarValue"/>
    <label for="star5" title="text">5 stars</label>
    <input type="radio" id="star4" name="rate" value="4" @change="storeStarValue"/>
    <label for="star4" title="text">4 stars</label>
    <input type="radio" id="star3" name="rate" value="3" @change="storeStarValue"/>
    <label for="star3" title="text">3 stars</label>
    <input type="radio" id="star2" name="rate" value="2" @change="storeStarValue"/>
    <label for="star2" title="text">2 stars</label>
    <input type="radio" id="star1" name="rate" value="1" @change="storeStarValue"/>
    <label for="star1" title="text">1 star</label>
  </div>
</template>

<script>
export default {
  name: "StarRating",
  methods: {
    storeStarValue(e) {
      console.log(e.target.value);
      this.$store.commit("updateStarRating", e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.rate {
  float: left;
  height: 5rem;
  padding: 0 1rem;
}
.rate:not(:checked) > input {
  position:absolute;
  top:-999rem;
}
.rate:not(:checked) > label {
  float:right;
  width:1em;
  overflow:hidden;
  white-space:nowrap;
  cursor:pointer;
  font-size:4rem;
  color:white;
}
.rate:not(:checked) > label:before {
  content: '★ ';
}
.rate > input:checked ~ label {
  color: #ffc700;
}
.rate:not(:checked) > label:hover,
.rate:not(:checked) > label:hover ~ label {
  color: #deb217;
}
.rate > input:checked + label:hover,
.rate > input:checked + label:hover ~ label,
.rate > input:checked ~ label:hover,
.rate > input:checked ~ label:hover ~ label,
.rate > label:hover ~ input:checked ~ label {
  color: #c59b08;
}
</style>